import React, {useState} from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components';
import {Grid, Box} from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import ResponsiveImage from '../../ui/RespImg';
import ModelCarousel from '../ModelCarouselNew';
import { theme } from '../../../themes/default-theme';
import Text from '../../typography';
import NextLink from '../../navigation/NextLink'
import Cta from '../../ui/Cta'
import { get } from 'lodash';
import HeartIcon from '../../../assets/icons/new-heart-white.svg';
import HeartFilledIcon from '../../../assets/icons/new-heart-white-filled.svg';
import DownloadIcon from '../../../assets/icons/download-white.svg';
import LocationIcon from '../../../assets/icons/location-white.svg';
import { ReactSVG } from 'react-svg';
import SharePopup from '../../ui/SharePopup';
import Modal from '../../ui/Modal';


const Container = styled.div`
    ${props => props.theme === 'dark' && `
        background-color: black
    `}
`

const Img = styled.div`
    height: 200px;
    overflow: hidden;
    position: relative;
    &:before {
        content: '';
        background: linear-gradient(0deg, rgba(46, 50, 56, 0.00) 9.26%, rgba(46, 50, 56, 0.50) 107.41%);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        z-index: 1;
    }
    picture,
    img {
        object-fit: cover;
        object-position: center;
        height: 100%;
    }

    ${theme.breakpoints.up('lg')} {
        height: 300px;
    }
`

const CarouselWrapper = styled.div`
    position: relative;
    z-index: 3;
    ${props => props.length == 'multi' && `
        ${theme.breakpoints.up('md')} {
            .slick-slider {
                margin-bottom: 20px;
            }
        }
    `}
`

const Carousel = styled.div`
    max-width: 707px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -100px;
    overflow: hidden;
    ${theme.breakpoints.up('lg')} {
        margin-top: -150px;
        max-width: 100%;
    }
    
`

const Thumbnails = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    ${theme.breakpoints.up('md')} {
        margin-top: 0;
    }
`

const Thumbnail = styled.li`
    display: inline-block;
    max-width: 125px;
    padding: 0 10px;
    opacity: 0.5;
    padding-bottom: 30px;
    cursor: pointer;

    ${theme.breakpoints.up('md')} {
        max-width: 173px;
    }

    ${theme.breakpoints.down('sm')} {
        ${props => props.length && `
            width: calc(100% / ${props.length});    
        `
        }
    }

    ${props => props.active && `
        opacity: 1;
    `}
`

const ModelNameContainer = styled.div`
    margin-top: 20px;
    display: inline-block;
    padding: 0 20px;
    position: relative;
    ${theme.breakpoints.down('sm')} {
        padding: 0;
        ${props => props.length && `
           > span {
                padding: 0 20px;
           }
        `
        }
    }
`

const ModelName = styled.span`
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
    color: ${theme.palette.charcoal};
    text-transform: uppercase;

    ${props => props.theme === 'dark' && `
        color: white;
    `}

    &:after {
        content: '';
        width: 0;
        position: absolute;
        bottom: -15px;
        left: 0;
        right: 0;
        margin: auto;
        transition: width 300ms ease;
        height: 6px;
        background-color: ${theme.palette.vividBlue};
    }

    ${props => props.active && `
        &:after {
            width: 100%;
        }
    `}
`

const CtasContainer = styled.div`
    font-size: 0;
    ${theme.breakpoints.up('md')} {
        margin-top: 20px;
    }
`

const Content = styled.div`
    margin-top: 43px;
    ${theme.breakpoints.down('sm')} {
        margin-top: 19px;
        h1 {
            font-size: 32px;
            line-height: 32px;
            letter-spacing: 1px;
            margin-bottom: 14px;
        }
        h5 {
            margin-bottom: 14px;
        }
    }
    ${theme.breakpoints.up('lg')} {
        padding-left: 20px;
        max-width: 580px;
        h1 {
            font-size: 64px;
            line-height: 64px;
            letter-spacing: 2px;
            margin-bottom: 22px;
        }
        h5 {
            margin-bottom: 22px;
        }
    }

    h5 {
        line-height: 22px;
    }

    ${theme.breakpoints.down('sm')} {
        h1,h5,p {
            text-align: center;
        }
    }
`

const CtaItem = styled.div`
    display: inline-block;
    margin-right: 14px;
    margin-bottom: 14px;

    ${theme.breakpoints.down('sm')} {
        margin-bottom: 0;
    }
`

const MobileCtas = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    z-index: 10;
    padding: 8px 20px;
    align-items: center;
    ${props => props.colourTheme === 'dark' ? `
        background-color:  ${theme.palette.charcoal};
    ` : `
        background-color: ${theme.palette.white};

        svg {
            [stroke] {
                stroke: ${theme.palette.vividBlue};
            }
            [fill] {
                fill: ${theme.palette.vividBlue};
            }
        }
    `}
`

const MobileCtaIcons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 111px;
    align-items: center;
`

const IconSvg = styled(ReactSVG)`
    position: relative;
    top: -1px;
    svg {
        vertical-align: middle;
    }
`

const SeriesHeroBanner = (props) => {
    const {
        image,
        series,
        title,
        subTitle,
        text,
        ctas,
        width,
        colourTheme
    } = props

    const [activeSeries, setActiveSeries] = useState(0);
    const [modal, setModal] = useState(false);

    const transformedCtas = ctas.map(item => {
        if (item.href === '/dealers' && process.env.DEALER_SITE) {
            return {
                ...item,
                href: '/contact-us',
                title: 'Get in touch'
            }
        }
        return item
    }) 
    
    // console.log('CTAZ', transformedCtas);

    const cta1 = get(transformedCtas, '[0]', null);

    return (
        <>
            <Modal
                isOpen={modal && !isWidthUp('md', width)}
                onClose={() => setModal(false)}
                iconVividBlue={true}
                innerClassname={'share-container'}
                thickCloseIcon={true}
            >
                <SharePopup 
                    onShareClick={props.onShareClick}
                />
            </Modal>
            <Container theme={colourTheme}>

                {image &&
                    <Img>
                        <ResponsiveImage {...image} />
                    </Img>
                }

                {series[activeSeries] &&
                    <CarouselWrapper length={series[activeSeries]?.carousel?.length > 0 && series[activeSeries].carousel.length > 1 ? 'multi' : 'single'}>
                        <Grid container spacing={0} direction={'row'} justify={'space-between'} >
                            <Grid item xs={12} lg={6}>
                                <Box px={0}>
                                    <Carousel>
                                        <ModelCarousel 
                                            key={activeSeries} // re-render carousel
                                            items={series[activeSeries].carousel}
                                            theme={colourTheme}
                                        />
                                        {(series && isWidthUp('md', width) && series.length > 1) &&
                                            <Thumbnails>
                                                {series.map((item, index) => {
                                                    return (
                                                        <Thumbnail key={item.id || index} active={index === activeSeries} onClick={() => setActiveSeries(index)}>
                                                            {item.carousel && item.carousel[0] && item.carousel[0].image &&
                                                                <ResponsiveImage {...item.carousel[0].image} type="png"/>
                                                            }
                                                            <ModelNameContainer>
                                                                <ModelName theme={colourTheme} active={index === activeSeries}>
                                                                    {item.title}
                                                                </ModelName>
                                                            </ModelNameContainer>
                                                        </Thumbnail>
                                                    )
                                                })
                                            }
                                            </Thumbnails>

                                        }
                                    </Carousel>
                                </Box>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Box px={2}>
                                    <Content>
                                        {title &&
                                            <Text colour={colourTheme === 'dark' ? "white" : "charcoal"} variant="h1" uppercase>{title}</Text>
                                        }
                                        {subTitle &&
                                            <Text colour={colourTheme === 'dark' ? "white" : "charcoal"} variant="h5">{subTitle}</Text>
                                        }
                                        {text &&
                                            <Text colour={colourTheme === 'dark' ? "white" : "charcoal"} variant="body1">
                                                <div dangerouslySetInnerHTML={{__html: text}} />
                                            </Text>
                                        }
                                        {(transformedCtas && transformedCtas.length > 0) &&
                                            <CtasContainer>
                                                {isWidthUp('md', width) ?
                                                    transformedCtas.map((cta, index) => (
                                                        <CtaItem key={cta.href || index}>
                                                            <NextLink href={cta.href}>
                                                                <a>
                                                                    <Cta outline={index === 1 ? true : false} outlineWhite={colourTheme === 'dark' ? true : false} inline>
                                                                        {cta.title}
                                                                    </Cta>
                                                                </a>
                                                            </NextLink>
                                                        </CtaItem>
                                                    ))
                                                :
                                                    <MobileCtas colourTheme={colourTheme}>
                                                        <CtaItem>
                                                            {cta1 &&
                                                                <NextLink href={cta1.href}>
                                                                    <a>
                                                                        <Cta inline>
                                                                            {cta1.title}
                                                                        </Cta>
                                                                    </a>
                                                                </NextLink>
                                                            }
                                                        </CtaItem>
                                                        <MobileCtaIcons>
                                                            {process.env.DEALER_SITE ? 
                                                            <NextLink href={'/contact-us'}>
                                                                <a aria-label="Get in touch">
                                                                    <IconSvg src={LocationIcon} />
                                                                </a>
                                                            </NextLink>
                                                            : 
                                                            <NextLink href={'/dealers'}>
                                                                <a aria-label="Go to dealers">
                                                                    <IconSvg src={LocationIcon} />
                                                                </a>
                                                            </NextLink>
                                                            }

                                                            <IconSvg src={props.saved ? HeartFilledIcon : HeartIcon} onClick={props.onSave}/>
                                                            <IconSvg src={DownloadIcon} onClick={() => setModal(true)}/>
                                                        </MobileCtaIcons>
                                                    </MobileCtas>
                                                }
                                            </CtasContainer>
                                        }
                                    </Content>
                                    {(series && !isWidthUp('md', width) && series.length > 1) &&
                                        <Thumbnails>
                                            {series.map((item, index) => {
                                                return (
                                                    <Thumbnail key={item.id || index} active={index === activeSeries} onClick={() => setActiveSeries(index)} length={series.length}>
                                                        {item.carousel && item.carousel[0] && item.carousel[0].image &&
                                                            <ResponsiveImage {...item.carousel[0].image} type="png"/>
                                                        }
                                                        <ModelNameContainer>
                                                            <ModelName theme={colourTheme} active={index === activeSeries}>
                                                                {item.title}
                                                            </ModelName>
                                                        </ModelNameContainer>
                                                    </Thumbnail>
                                                )
                                            })
                                        }
                                        </Thumbnails>

                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </CarouselWrapper>
                }
            </Container>
        </>
    )
}
    
SeriesHeroBanner.propTypes = {
    theme: propTypes.string
}
    
SeriesHeroBanner.defaultProps = {
    colourTheme: 'light',
    onSave: () => {},
    saved: false,
    onShareClick: () => {}
}
    
export default withWidth()(SeriesHeroBanner)